var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.0459,
    height: 22.0459,
    rx: 2.18918,
    fill: "#14C864"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7.62524V5.75024M10.75 7.62524C9.7125 7.62524 8.875 7.62524 8.875 8.87524C8.875 10.7502 12.625 10.7502 12.625 12.6252C12.625 13.8752 11.7875 13.8752 10.75 13.8752M10.75 7.62524C11.7875 7.62524 12.625 8.10024 12.625 8.87524M8.875 12.6252C8.875 13.5627 9.7125 13.8752 10.75 13.8752M10.75 13.8752V15.7502",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 10.7512C18.125 14.8243 14.8231 18.1262 10.75 18.1262C6.6769 18.1262 3.375 14.8243 3.375 10.7512C3.375 6.67812 6.6769 3.37622 10.75 3.37622C14.8231 3.37622 18.125 6.67812 18.125 10.7512Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.8df64c39e9488f99972db6aadc359d22.svg";
export { ForwardRef as ReactComponent };